export default "__VITE_ASSET__CADs8Ict__"